import React, { useEffect, useRef } from 'react';
import L from 'leaflet';
import { placeCategories, type Place } from '../../data/plan';
import { profileCoordinates } from '../../data/demandes';
import { token } from '../../utils/theme';
interface DropOffMapProps {
  places: Place[];
  /** Lieu mis en avant (le plus proche). */
  highlightId: string;
}

/** Petite carte des points de dépôt autour du domicile, affichée dans la réponse d'ATNA. */
export function DropOffMap({
  places,
  highlightId
}: DropOffMapProps) {
  const containerRef = useRef<HTMLDivElement | null>(null);
  useEffect(() => {
    if (!containerRef.current) return;
    const map = L.map(containerRef.current, {
      zoomControl: false,
      scrollWheelZoom: false,
      attributionControl: true
    });
    map.attributionControl.setPrefix(false);
    L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png', {
      maxZoom: 19,
      attribution: '© OpenStreetMap'
    }).addTo(map);
    L.circleMarker(profileCoordinates, {
      radius: 7,
      color: '#ffffff',
      weight: 3,
      fillColor: token('--ville-navy', '#16265c'),
      fillOpacity: 1
    }).bindTooltip('Votre adresse').addTo(map);
    places.forEach(place => {
      const active = place.id === highlightId;
      const size = active ? 30 : 20;
      L.marker([place.lat, place.lng], {
        icon: L.divIcon({
          className: 'plan-pin',
          html: `<span style="background:${placeCategories[place.category].color};width:${size}px;height:${size}px" class="block rounded-full border-[3px] border-white shadow-md shadow-ville-navy/30"></span>`,
          iconSize: [size, size],
          iconAnchor: [size / 2, size / 2]
        }),
        title: place.name,
        alt: place.name,
        zIndexOffset: active ? 500 : 0
      }).bindTooltip(place.name, {
        permanent: active,
        direction: 'top',
        offset: [0, -14]
      }).addTo(map);
    });
    const bounds = L.latLngBounds([profileCoordinates, ...places.map(place => [place.lat, place.lng] as [number, number])]);
    map.fitBounds(bounds, {
      padding: [28, 28]
    });
    return () => {
      map.remove();
    };
  }, [places, highlightId]);
  return <div ref={containerRef} role="img" aria-label="Carte des points de dépôt de piles et batteries près de chez vous" className="h-56 w-full bg-ville-mist" data-id="element-1029" data-mp="2vmt3n63567s9" />;
}